import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const processed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    api.post("/auth/google/session", { session_id: m[1] })
      .then((r) => {
        setUser(r.data.user);
        window.history.replaceState({}, "", "/");
        const to = r.data.user.role === "admin" ? "/admin" : r.data.user.role === "casting" ? "/dashboard/casting" : (r.data.user.subscription ? "/dashboard/talent" : "/pricing");
        nav(to);
      })
      .catch(() => nav("/login"));
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center">
      <div className="text-center">
        <div className="sv-overline mb-3">Signing you in</div>
        <div className="font-serif-hero text-2xl">One moment…</div>
      </div>
    </div>
  );
}
